import { Checkbox, Flex, FormControl, Text, VStack } from '@chakra-ui/react';
import capitalize from 'lodash/capitalize';

import { useLibraryFilters } from '@/components/ui/features/library/LibraryFilter/LibraryFilter.hooks';
import { useAnalytics } from '@/context/Analytics';
import { LibraryFilter } from '@/enums/LibraryFilter';
import { useLibLynx } from '@/hooks/useLibLynx';
import { useQueryParams } from '@/hooks/useQueryParams';
import { useResource, useResourceRelationship } from '@/lib/datx-jsonapi-react';
import { getHubBySlug, getHubsSubtree } from '@/queries/hubs';
import { queryOmnisearchThinLectureFiltersRelationship } from '@/queries/omnisearch-thin-lectures';
import { StringArrayParams, StringParam } from '@/utils/url-query-string';

export const FilterContentType = () => {
  const analytics = useAnalytics();
  const libLynx = useLibLynx();

  const { filters, change } = useLibraryFilters({
    [LibraryFilter.Tag]: StringArrayParams,
  });

  const { query, slug } = useQueryParams<{ query: string; slug: string }>({
    query: StringParam,
    slug: StringParam,
  });

  const { data: hubsData } = useResource(getHubBySlug(slug));
  const {
    data: { subtreeIds },
  } = useResourceRelationship(getHubsSubtree(hubsData.id));

  const { data } = useResource(
    queryOmnisearchThinLectureFiltersRelationship({
      library: 'true',
      scope: 'published',
      subject_id: subtreeIds,
      query,
      ...filters,
    })
  );

  const currentFilters = filters[LibraryFilter.Tag] || [];

  const onUpdate = (tag) => {
    let updatedFilters = [];
    const id = tag.value.toString();

    if (currentFilters.includes(id)) {
      updatedFilters = currentFilters.filter((currentItem) => currentItem !== id);
    } else {
      updatedFilters = [...currentFilters, id];
    }

    change(
      { [LibraryFilter.Tag]: updatedFilters.join(',') || undefined },
      { method: 'replace', shallow: true, scroll: true }
    );
    analytics.track('library_content_filter', { content_type_name: tag.name, content_type_id: id });
    libLynx.send('trackSearch');
  };

  return (
    <FormControl px={4} as="fieldset">
      <VStack alignItems="flex-start">
        {data?.tags?.map((tag) => {
          return (
            <Flex w="full" key={tag.value}>
              <Checkbox
                isChecked={currentFilters.includes(tag.value.toString())}
                name={LibraryFilter.Tag}
                value={tag.value}
                colorScheme="violet"
                size="lg"
                onChange={() => {
                  onUpdate(tag);
                }}
              >
                <Text as="span" textStyle="groteskS">
                  {capitalize(tag.label)} ({tag.amount})
                </Text>
              </Checkbox>
            </Flex>
          );
        })}
      </VStack>
    </FormControl>
  );
};
